<template>
  <div class="check-list">
    <h1 class="title is-4">
      {{ checkList.name }}
    </h1>
    <div class="swiper-container" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(slide, index) in virtualData.slides" :key="index" :style="{left: `${virtualData.offset}px`}">
          <div v-if="slide.begin === true">
            <p class="pad">{{ checkList.description }}</p>
            <div class="text-center pad">
              <button class="button is-info" @click="begin">Begin Check List</button>
            </div>
          </div>
          <div v-else-if="slide.summary !== true" class="box">

            <!-- PROGRESS -->
            <div class="slide-indicator">
              {{ slide.index + 1 }} / {{ checkList.checks.length }}
            </div>

            <!-- DESC -->
            <h2 class="description">{{ slide.name }}</h2>

            <!-- TYPE CHECKBOX -->
            <div class="body">
              <div class="checkbox" v-if="slide.type === 'checkbox'">
                <div class="check-option" :class="{no: slide.value === 'no'}">
                  <font-awesome-icon icon="times" size="7x" @click="updateValue(slide.index, 'no')" />
                </div>
                <div class="check-option" :class="{yes: slide.value === 'yes'}">
                  <font-awesome-icon icon="check" size="7x" @click="updateValue(slide.index, 'yes')" />
                </div>
              </div>

              <!-- TYPE TEXT -->
              <div class="text-input full-width" v-else-if="slide.type === 'text'">
                <textarea v-model="slide.value" @input="updateValue(slide.index, $event.target.value)"></textarea>
              </div>

              <!-- TYPE NUMBER -->
              <div class="number" v-else-if="slide.type === 'number'">
                <input class="text-center" type="number"
                  v-model="slide.value"
                  @input="updateValue(slide.index, $event.target.value)"
                  :min="slide.min ? slide.min : ''"
                  :max="slide.max ? slide.max : ''"
                  :placeholder="slide.placeholder ? slide.placeholder : ''" />
              </div>

              <!-- TYPE UNKOWN -->
              <div class="unknown-type" v-else>
                Something went wrong let Shaun know about it and he'll fix it
              </div>
            </div>

            <div class="pointer bold text-center" v-if="slide.type === 'checkbox' && slide.allowNa">
               <span class="title is-3" :class="{'has-text-grey-light': slide.value !== 'na'}" @click="updateValue(slide.index, 'na')">NA</span>
            </div>

            <!-- COMMENT -->
            <div class="comment">
              <b v-if="slide.requiredIfFalse && slide.value === 'no'">Comment required</b>
              <textarea v-if="slide.showComment"
                v-model="slide.comment"
                :placeholder="slide.requiredIfFalse && slide.value === 'no' ? 'comment required' : 'comment'"
                @input="commentUpdated(slide.index, $event.target.value)">
              </textarea>
            </div>

            <div class="flex">
              <div class="flex-1 pad">
                <button class="button" @click="prev" v-if="slideIndex > 0">
                  <font-awesome-icon icon="arrow-left" />
                </button>
              </div>
              <div class="flex-1 pad text-right">
                <button class="button" :disabled="!allowNext" @click="next">
                  <font-awesome-icon icon="arrow-right" />
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <check-list-summary :check-list="checkList" @check-click="jumpTo" />
            <br />
            <button class="button is-info" @click="submit">{{ submitTitle }}</button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CheckListSummary from '@/components/CheckListSummary'
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper/dist/js/swiper.esm.bundle'
import { CheckListsHelper } from '@/utils/checkLists.js'
export default {
  name: 'CheckList',
  props: {
    checkList: { reuired: true },
    submitTitle: { default: 'Submit Check List' }
  },
  components: {
    CheckListSummary
  },
  data () {
    return {
      msg: 'none',
      swiper: null,
      virtualData: {
        slides: []
      },
      allowNext: false,
      slideIndex: -1,
      maxAnsweredIndex: -1,
      mounted: false
    }
  },
  computed: {
    currentCheck () {
      return this.slideIndex < this.checkList.checks.length ? this.checkList.checks[this.slideIndex] : null
    }
  },
  watch: {
    checkList () {
      this.prepareCheckList()
      this.initSlider()
    },
    slideIndex () {
      this.swiper.allowSlidePrev = this.slideIndex > 0
      this.updateAllowNext()
    }
  },
  created () {
    this.prepareCheckList()
  },
  mounted () {
    this.mounted = true
    this.initSlider()
  },
  methods: {
    begin () {
      this.checkList.timestampStarted = this.$moment().unix()
      this.next()
    },
    prepareCheckList () {
      if (!this.checkList) {
        return
      }

      this.checkList.checks.forEach(check => {
        check.comment = ''
        check.value = ''
      })
    },
    submit () {
      this.checkList.timestampEnded = this.$moment().unix()
      this.checkList.duration = this.checkList.timestampEnded - this.checkList.timestampStarted
      this.$emit('submit', this.checkList)
    },
    jumpTo (i) {
      this.swiper.slideTo(i + 1, 500)
    },
    prev () {
      this.swiper.slidePrev(500)
    },
    next () {
      if (this.allowNext) {
        this.swiper.slideNext(500)
      }
    },
    updateAllowNext () {
      let allowNext = true
      if (this.slideIndex >= 0) {
        if (this.slideIndex >= this.checkList.checks.length) {
          allowNext = false
        } else if (CheckListsHelper.validateCheck(this.currentCheck) !== true) {
          allowNext = false
        }
      }

      this.allowNext = allowNext
      this.swiper.allowSlideNext = allowNext
      return allowNext
    },
    commentUpdated (i, value) {
      this.$set(this.checkList.checks[i], 'comment', value)
      this.msg = this.checkList.checks[i].comment
      this.updateAllowNext()
    },
    updateValue (i, value) {
      this.maxAnsweredIndex = Math.max(this.maxAnsweredIndex, i)
      this.$set(this.checkList.checks[i], 'value', value)
      if (this.updateAllowNext() && this.checkList.checks[i].type === 'checkbox') {
        setTimeout(this.next, 300)
      }
    },
    initSlider () {
      if (!this.mounted || !this.checkList) {
        return
      }
      const self = this
      let slides = [{ begin: true }]
      self.checkList.checks.forEach(c => slides.push(c))
      slides.push({ summary: true })
      this.swiper = new Swiper(this.$refs.swiperContainer, {
        spaceBetween: 30,
        threshold: 10,
        allowSlidePrev: false,
        allowSlideNext: false,
        virtual: {
          slides: slides,
          renderExternal (data) {
            for (let i = 0; i < data.slides.length; i++) {
              data.slides[i].index = data.from + i - 1
            }
            self.virtualData = data
          }
        },
        on: {
          slideChange () {
            self.slideIndex = self.swiper.realIndex - 1
          }
        }
      })
      this.updateAllowNext()
    }
  }
}
</script>

<style>
.check-list {
  height: 100%;
}

.check-list .swiper-slide .box {
  display: flex;
  flex-direction: column;
  margin: 0;
  height: 99%;
  padding: 0;
  background-color: #eee;
  border: solid 2px #999;
}

.check-list .swiper-slide .box .slide-indicator { flex: 0.5; }
.check-list .swiper-slide .box .description { flex: 3; }
.check-list .swiper-slide .box .body { flex: 5; }
.check-list .swiper-slide .box .comment { flex: 2; }

.check-list .swiper-slide .box .slide-indicator {
  text-align: left;
  font-weight: bold;
  padding: 10px;
  color:#666;
}

.check-list .swiper-slide .box .description {
  font-size: 1.5em;
  color: #333;
  display: flex;
  align-items: center;
  padding: 20px 10px;
  justify-content: center;
  text-align: center;
}

.check-list .swiper-slide .box .body {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 30px 10px;
}

.check-list .swiper-slide .box .comment,
.check-list .swiper-slide .box .text-input {
  text-align: center;
  padding: 10px 32px 10px 10px;
}

.check-list .swiper-slide .box .checkbox {
  width: 100%;
  height: 100%;
  display: flex;
}

.check-list .swiper-slide .box .check-option {text-align: center;
  flex: 1;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: hsl(0, 0%, 86%);
  cursor: pointer;
}

.check-list .swiper-slide .box .check-option .title {
  color: hsl(0, 0%, 71%);
  margin-top: 15px;
}

.check-list .swiper-slide .box .check-option.yes {
  color: hsl(141, 71%, 48%);
  border-color: hsl(141, 71%, 48%);
}

.check-list .swiper-slide .box .check-option.no {
  color: hsl(348, 100%, 61%);
  border-color: hsl(348, 100%, 61%);
}

.check-list .swiper-slide .box .check-option.yes .title,
.check-list .swiper-slide .box .check-option.no .title {
  color: hsl(0, 0%, 29%);
}

.check-list .swiper-slide .box input,
.check-list .swiper-slide .box textarea {
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  font-size: 1.5em;
  border: solid 1px #999;
  border-radius: 5px;
}

.check-list .swiper-slide .box textarea { height: 85px; }

</style>
